// @ts-nocheck
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  shouldLibraryReload: false,
  shouldLibraryClose: true,
  isDragging: false,
  items: [],
  libraryLineItems: [],
  itinerary: {
    isTripDaysDraggableDisabled: false,
    isTripDayItemDraggableDisabled: false,
    isDayContentDraggableDisabled: false,
    isDayLineItemDraggableDisabled: false,
    isLibraryDraggableDisabled: false,
    isTripContentListDraggableDisabled: false,
    isTripContentDataDraggableDisabled: false,
    isDayLibraryServiceDraggableDisabled: false,
    draggableAction: {}
  }
};

const librarySlice = createSlice({
  name: 'library',
  initialState,
  reducers: {
    addIsDragging: (state, action) => {
      const { isDragging = false } = action.payload;

      return {
        ...state,
        isDragging
      };
    },
    addShouldLibraryReload: (state, action) => {
      const { shouldLibraryReload = false } = action.payload;

      return {
        ...state,
        shouldLibraryReload
      };
    },
    addShouldLibraryClose: (state, action) => {
      const { shouldLibraryClose = false } = action.payload;

      return {
        ...state,
        shouldLibraryClose
      };
    },
    addLibraryItems: (state, action) => {
      const { items = [] } = action.payload;

      return {
        ...state,
        items
      };
    },
    addDraggableStatus: (state, action) => {
      const { context, data } = action.payload;

      return {
        ...state,
        [context]: { ...data }
      };
    },
    addDraggableAction: (state, action) => {
      const { context, data } = action.payload;

      if (!state[context] || !state[context].draggableAction) {
        return {
          ...state,
          [context]: {
            draggableAction: { ...data }
          }
        };
      }

      return {
        ...state,
        [context]: {
          ...state[context],
          draggableAction: { ...data }
        }
      };
    },
    cleanDraggableStatus: (state, action) => {
      const { payload = {} } = action;
      const { shouldLibraryClose = false } = payload;
      return {
        ...initialState,
        shouldLibraryClose: shouldLibraryClose,
        items: state.items ?? [],
        itinerary: {
          ...initialState.itinerary,
          draggableAction: state.itinerary.draggableAction
        }
      };
    },
    cleanDraggableAction: (state, action) => {
      const { payload = {} } = action;
      const { shouldLibraryClose } = payload;

      return {
        ...state,
        shouldLibraryClose:
          shouldLibraryClose !== undefined
            ? shouldLibraryClose
            : state.shouldLibraryClose,
        itinerary: {
          ...state.itinerary,
          draggableAction: {}
        }
      };
    },
    // Library LineItem actions
    setLibraryLineItems: (state, action) => {
      state.libraryLineItems = action.payload || [];
    },
    addLibraryLineItem: (state, action) => {
      state.libraryLineItems.push(action.payload);
    },
    updateLibraryLineItem: (state, action) => {
      const index = state.libraryLineItems.findIndex(
        (item) => item.lineitemid === action.payload.lineitemid
      );
      if (index >= 0) {
        state.libraryLineItems[index] = action.payload;
      }
    },
    removeLibraryLineItem: (state, action) => {
      state.libraryLineItems = state.libraryLineItems.filter(
        (item) => item.lineitemid !== action.payload
      );
    }
  }
});

const { actions, reducer } = librarySlice;

export const {
  addShouldLibraryReload,
  addShouldLibraryClose,
  addIsDragging,
  addLibraryItems,
  addDraggableStatus,
  addDraggableAction,
  cleanDraggableStatus,
  cleanDraggableAction,
  setLibraryLineItems,
  addLibraryLineItem,
  updateLibraryLineItem,
  removeLibraryLineItem
} = actions;

export default reducer;
